export default "/images/aabd85ad76cab588e638d417d5efaaba.jpg";